import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './features17.css'

const Features17 = (props) => {
  return (
    <div className="features17-layout349 thq-section-padding">
      <div className="features17-max-width thq-section-max-width">
        <div className="features17-image-container">
          <img
            alt={props.feature1ImageAlt}
            src={props.feature1ImageSrc}
            className="thq-img-ratio-16-9"
          />
        </div>
        <div className="features17-content1">
          <div className="features17-section-title">
            <div className="features17-content2">
              <h2>
                {props.feature1Title ?? (
                  <Fragment>
                    <h2 className="features17-text26 thq-heading-2">
                      Commonwealth AI Incubator
                    </h2>
                  </Fragment>
                )}
              </h2>
              <p>
                {props.feature1Description ?? (
                  <Fragment>
                    <p className="features17-text12 thq-body-large" style={{ textAlign: 'justify' }}>
                      <span>
                        This is available for youths including women who would like to benefit from learnings partnering 
                        with universities and build solutions in areas relating to the SDG. The aim is again to integrate effectively 
                        AI education in universities and enhance cross-regional integration and Multilingualism through AI. A total of 
                        2 million euros is committed to this by OBREAL Global for 5 years. You can find more details about the selected 
                        students and projects from the first call addressed to Africa in the document below.
                      </span>
                    </p>
                    <span className="initiatives-text35 thq-body-large" style={{ textAlign: 'justify'}}>
          <a
            href="/AI_Incubator.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="initiatives-link thq-body-large"
            
          >
            <h5>View Document</h5>
          </a>
          <a
          href="https://thecommonwealth.org/events/youth-incubator-ai-innovation-and-multilingualism-global-development"
          target="_blank"
          rel="noopener noreferrer"
          className="initiatives-link thq-body-large"
        >
          <h5>Learn More...</h5>
        </a>
        </span>
                  </Fragment>
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Features17.defaultProps = {
  feature1Description: undefined,
  feature1ImageAlt: 'Image depicting ethical AI standards',
  feature1Title: undefined,
  feature1ImageSrc: '/25.jpg',
}

Features17.propTypes = {
  feature1Description: PropTypes.element,
  feature1ImageAlt: PropTypes.string,
  feature1Title: PropTypes.element,
  feature1ImageSrc: PropTypes.string,
}

export default Features17
